// Anexos do negocio: regras puras (sem banco, sem rede). Quem fala com o Supabase e `criarApi` (src/data/api.js).
//
// Spec: docs/superpowers/specs/2026-10-02-anexos-do-negocio-storage.md (§7). Migration 0098.
// A lista de extensoes e o teto de tamanho aparecem em TRES lugares que precisam concordar: aqui (para avisar antes de enviar), no
// Storage/`anexos` (CHECK e politica, que sao quem de fato barra) e no teto do bucket. Esta copia so existe para a mensagem sair
// antes de gastar o envio; o banco continua sendo a autoridade.

export const BUCKET_ANEXOS = 'anexos';
export const EXTENSOES_ANEXO = ['pdf', 'dwg', 'dxf', 'xlsx', 'csv', 'png', 'jpg', 'jpeg'];
export const TAMANHO_MAX_BYTES = 52428800; // 50 MB

// Navegador costuma mandar `type` vazio para DWG/DXF. Sem tipo o Storage guarda como texto e o download vem errado.
const TIPO_POR_EXTENSAO = {
  pdf: 'application/pdf',
  dwg: 'application/octet-stream',
  dxf: 'application/octet-stream',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  csv: 'text/csv',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};

export function extensaoDe(nome) {
  const t = String(nome || '');
  const i = t.lastIndexOf('.');
  return i > 0 && i < t.length - 1 ? t.slice(i + 1).toLowerCase() : '';
}

export function tipoDoArquivo(arquivo) {
  return TIPO_POR_EXTENSAO[extensaoDe(arquivo?.name)] || arquivo?.type || 'application/octet-stream';
}

/** Confere o arquivo ANTES de gastar o envio. Devolve { ok: true } ou { ok: false, motivo } com texto para a tela. */
export function validarArquivo(arquivo) {
  if (!arquivo || !arquivo.name) return { ok: false, motivo: 'Arquivo inválido.' };
  const ext = extensaoDe(arquivo.name);
  if (!ext) return { ok: false, motivo: `"${arquivo.name}" não tem extensão. Tipos aceitos: ${EXTENSOES_ANEXO.join(', ')}.` };
  if (!EXTENSOES_ANEXO.includes(ext)) {
    return { ok: false, motivo: `"${arquivo.name}": tipo .${ext} não é aceito. Tipos aceitos: ${EXTENSOES_ANEXO.join(', ')}.` };
  }
  if (!(arquivo.size > 0)) return { ok: false, motivo: `"${arquivo.name}" está vazio.` };
  if (arquivo.size > TAMANHO_MAX_BYTES) {
    return { ok: false, motivo: `"${arquivo.name}" passa de 50 MB (${(arquivo.size / 1048576).toFixed(1)} MB).` };
  }
  return { ok: true };
}

/**
 * O Storage recusa caracteres que o nome de um arquivo no Windows aceita (acento, espaco, parenteses...). O nome ORIGINAL fica em
 * `anexos.nome` (e e o que a pessoa ve); este e so o do caminho. Nunca contem `/`, o que impediria fugir da pasta do negocio.
 */
export function nomeSeguro(nome) {
  const ext = extensaoDe(nome);
  const base = String(nome || '').replace(/\.[^.]*$/, '');
  const limpo = base
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^A-Za-z0-9_-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 100);
  return `${limpo || 'arquivo'}${ext ? `.${ext}` : ''}`;
}

export function caminhoDoAnexo(negocioId, nome, uuid) {
  return `negocio/${negocioId}/${uuid}-${nomeSeguro(nome)}`;
}

const dataBr = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('pt-BR');
};

/** Linha de `anexos` -> o formato que a ficha ja usa (AnexoRow). `nomePorId` completa o nome de quem enviou. */
export function mapearAnexo(linha, nomePorId = {}) {
  const bytes = Number(linha.tamanho_bytes) || 0;
  return {
    id: linha.id,
    nome: linha.nome,
    ext: String(linha.extensao || extensaoDe(linha.nome)).toLowerCase(),
    mime: linha.mime || null,
    sizeMB: Number((bytes / 1048576).toFixed(2)),
    pages: linha.paginas || null,
    uploadedAt: dataBr(linha.created_at),
    uploaderId: linha.uploader_id || null,
    uploader: nomePorId[linha.uploader_id] || 'usuário removido',
    storagePath: linha.storage_path,
  };
}
